// No.143 follow-up feature: 初診/再診 classification, mirrors
// App\Enums\ConsultationType on the backend (sheepmedical-api).
export const CONSULTATION_TYPE = {
  FIRST_CONSULTATION: 'first_consultation',
  FOLLOW_UP: 'follow_up',
};
